module.exports = __webpack_public_path__ + "img/citatorio_asamblea_2026.e56a0277.jpg";